import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ServiceHeaderProps {
  title: string;
  summary: string;
}

export default function ServiceHeader({ title, summary }: ServiceHeaderProps) {
  const { t } = useTranslation();

  return (
    <section className="relative bg-white pt-[72px] overflow-hidden">
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-br from-primary/5 via-white to-white" />

      <div className="relative max-w-[1400px] mx-auto px-6 py-20">
        <div className="flex flex-wrap items-center gap-2 mb-10 text-xs text-gray-400">
          <Link to="/" className="hover:text-primary transition-colors">
            {t('breadcrumb.home')}
          </Link>
          <i className="ri-arrow-right-s-line text-gray-300" />
          <Link to="/services" className="hover:text-primary transition-colors">
            {t('breadcrumb.services')}
          </Link>
          <i className="ri-arrow-right-s-line text-gray-300" />
          <span className="text-gray-500 line-clamp-1 max-w-[300px]">{title}</span>
        </div>

        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-gray-900 leading-tight mb-6">
            {title}
          </h1>
          <p className="text-gray-600 text-lg leading-relaxed border-l-2 border-primary pl-5">{summary}</p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent pointer-events-none" />
    </section>
  );
}
